import React from "react";
import {
  ServicesContainer,
  Bg,
  Container,
  Heading,
  Subheading,
  Container1,
  Bullets,
  Subheading2,
} from "./ServicesElements";
const Services = (props) => {
  return (
    <ServicesContainer id="whitepaper">
      <Bg>
        <Container>
          <Heading>What is the Trippy Chicks Club?</Heading>
          <Subheading>
            Trippy Chicks Club is a mind-bending collection of hallucinogenic
            bird NFTs (Non-Fungible Tokens) sure to inspire wonder and
            confusion! Spread your wings with the Trippy Chicks and enter a
            wonderful world of possibility!
            <br />
            Every Trippy Chick is a uniquely generated psychedelic bird from
            deep within the Metaversal Mind, hatched from a psychic egg and
            brought into the world through the blockchain and given form by a
            swirling chaotic pattern of colors and shapes. From the mildest
            Widgen to the most majestic Aquilla, the Trippy Chicks are here to
            brighten your world and inspire your creativity with their plumage.
          </Subheading>
        </Container>
        <Container1>
          <div>
            <Heading>Our philosophy </Heading>
            <Subheading2>
              We consider launching as a sign to direct us toward luck and
              prosperity, that is the reason why holding our NFTs will gain you
              more wealth and happiness!
              <br />
              Flying the skies of the Metaversal Mind gives the Trippy Chicks a
              colorful explosion of creativity that stays with them throughout
              their life. While each of the Trippy Chicks begins life as one of
              five broad types of birds, their time in the kaleidoscope skies of
              the metaverse touches each one in a unique way, coloring feathers,
              beaks, and eyes, all while reflecting the scintillating shimmers
              of the Metaversal Mind as it contemplates the universe of
              possibilities around it.
            </Subheading2>
          </div>
          <div>
            <Heading>Benefits of Minting Trippy chicks</Heading>
            <Subheading2>
              The Trippy Chicks project is an expansive project that will be
              exclusive to members who are part of an idealistic community
              providing an NFT collection to people who strive towards
              manifesting their dreams. These birds will attract all that is
              positive in the universe and you will be able to use that energy
              to work for yourself. These birds are rare objects that are highly
              in demand and if you have them you will be able to benefit from
              the virtues that each bird brings to make your dreams a reality.
              <br />
              By holding the Trippy Chicks on your wallet it’s not only going to
              increase your fortunes and luck but it will increase your wealth
              over a period of time.
            </Subheading2>
          </div>
        </Container1>

        <Container1>
          <div>
            <div style={{}}>
              <Heading>What makes us stand out? </Heading>

              <Bullets>
                1- Transparent and have working utilities in place. <br />
                2- Focused on making all stakeholders of the project happy.{" "}
                <br />
                3- Team has invested their own money before the NFT release and
                <br />
                will hold at least 20% of each NFT collection. Meaning - The
                team <br /> makes profit only like the stakeholders.
                <br />
                4- All the 10 utilities are already outlined and the specific
                functionality
                <br /> for each are already sorted out.
              </Bullets>
            </div>
          </div>
          <div>
            <div style={{}}>
              <Heading>Some exciting things on the way</Heading>
              <Bullets>
                1- App-based game or utility using the trippy chicks
                <br />
                2- Rarer trippy chicks as new NFTs <br />
                3- Trippy chick special Token <br />
                4- Giveaways <br />
              </Bullets>
            </div>
          </div>
        </Container1>
      </Bg>
    </ServicesContainer>
  );
};

export default Services;
